export const NAV4_OPT_OUT_FEEDBACK_GROUP_ID = 'nav4-opt-out';
